import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import DropDownComp from "./DropDownComp";
import DateTimePicker from "react-datetime-picker";
import InputComp from "./InputComp";
import { useDispatch, useSelector } from "react-redux";
import CONSTANTS from "../util/constants";
import Encrypt from "./../util/encrypt";
import "./../assets/css/datePicker.css";
import { moveTypeStatus } from "../util/constants/enumValue";
import CreatableSelect from "react-select/creatable";

const OffSiteModalComp = (props) => {
  console.log("123131offsite", props);
  const dispatch = useDispatch();
  const [isContainer, setIsContainer] = useState(
    props.rowDataUser && props.rowDataUser.outsideCarrierContainer_id != null
      ? true
      : false
  );
  const creatableInputRef = useRef(null);
  const [containerIdArray, setContainerIdArray] = useState([]);
  const containerArray = useSelector((state) => state.move.getContainerData);
  const [createContainerEnable, setCreateContainerEnable] = useState(false);

  useEffect(() => {
    if (containerArray && containerArray.length > 0) {
      var data = [];
      for (var i = 0; i < containerArray.length; i++) {
        data.push({
          label: containerArray[i].btId,
          value: containerArray[i]?.outsideCarrierContainer_id,
        });
      }

      if (
        props.rowDataUser?.outsideCarrierContainer_id != null &&
        props.rowDataUser?.outsideCarrierContainer_id != ""
      ) {
        setIsContainer(true);
        setIsTrailer(false);
        setContainerId({
          label: props.rowDataUser?.outsideCarrierContainer?.btId,
          value:
            props.rowDataUser?.outsideCarrierContainer
              ?.outsideCarrierContainer_id,
        });
      }
      setContainerIdArray(data);
      setCreateContainerEnable(false);
    }
  }, [containerArray]);

  const [comingFrom, setComingFrom] = useState("");
  const [isTrailer, setIsTrailer] = useState(
    props.rowDataUser && props.rowDataUser.outsideCarrierContainer_id != null
      ? false
      : true
  );

  const [goingTo, setGoingTo] = useState("");

  const [containerId, setContainerId] = useState(
    props.rowDataUser && props.rowDataUser.outsideCarrierContainer_id
      ? props.rowDataUser.outsideCarrierContainer_id
      : null
  );

  const [rowData, setrowDataValue] = useState(
    props.rowData ? props.rowData : {}
  );

  const [previousLoadVolume, setPreviousLoadVolume] = useState(
    props.rowDataUser?.trailer?.currentLoad
      ? {
          value: props.rowDataUser.trailer.currentLoad,
          label: props.rowDataUser.trailer.currentLoad,
        }
      : ""
  );

  const [newLoadVolume, setNewLoadVolume] = useState(
    props.rowDataUser?.newLoadVolume ? props.rowDataUser.newLoadVolume : ""
  );

  const [requestTime, setRequestTime] = useState(
    props.rowDataUser?.startDateTime
      ? props.rowDataUser.startDateTime
      : new Date()
  );

  const [requestFinishTime, setRequestFinishTime] = useState("");

  const [requesterName, setRequesterName] = useState(
    props.rowDataUser?.requesterName ? props.rowDataUser.requesterName : null
  );

  const [userId, setUserId] = useState(
    props.rowDataUser?.user_id ? props.rowDataUser.user_id : null
  );

  const [totalTime, setTotalTime] = useState();

  const [moveType, setMoveType] = useState(
    props.rowDataUser && props.rowDataUser.changeType
      ? {
          value: props.rowDataUser.changeType,
          label: props.rowDataUser.changeType,
        }
      : ""
  );

  const [departmentType, setDepartmentType] = useState(
    props.rowDataUser && props.rowDataUser.department
      ? {
          value: props.rowDataUser.department,
          label: props.rowDataUser.department,
        }
      : ""
  );

  const [driver, setDriver] = useState(
    props.rowDataUser && props.rowDataUser.driver
      ? {
          value: props.rowDataUser.driver?.user_id,
          label:
            props.rowDataUser.driver?.firstName +
            " " +
            props.rowDataUser.driver?.lastName,
        }
      : ""
  );

  const [truck, setTruck] = useState(
    props.rowDataUser && props.rowDataUser.truck
      ? {
          value: props.rowDataUser.truck?.truck_id,
          label: props.rowDataUser.truck?.type,
        }
      : ""
  );

  const [sealNumber, setSealNumber] = useState(
    props.rowDataUser && props.rowDataUser.sealNum
      ? props.rowDataUser.sealNum
      : ""
  );

  const [productNumber, setProductNumber] = useState(
    props.rowDataUser && props.rowDataUser.productNum
      ? props.rowDataUser.productNum
      : ""
  );

  const [actualCount, setActualCount] = useState(
    props.rowDataUser && props.rowDataUser.actualCount
      ? props.rowDataUser.actualCount
      : ""
  );

  const [comment, setComment] = useState(
    props.rowDataUser && props.rowDataUser.beforeComments
      ? props.rowDataUser.beforeComments
      : ""
  );

  const [afterComment, setAfterComment] = useState(
    props.rowDataUser && props.rowDataUser.afterComments
      ? props.rowDataUser.afterComments
      : ""
  );

  const [division, setDivision] = useState(
    props.rowDataUser && props.rowDataUser.division
      ? props.rowDataUser.division
      : ""
  );

  const [doorTo, setDoorTo] = useState(
    props.rowDataUser && props.rowDataUser.doorTo
      ? props.rowDataUser.doorTo
      : ""
  );

  const [doorFrom, setDoorFrom] = useState(
    props.rowDataUser && props.rowDataUser.doorFrom
      ? props.rowDataUser.doorFrom
      : ""
  );

  //move
  const [department, setDepartment] = useState(
    props.rowDataUser && props.rowDataUser.department
      ? {
          value: props.rowDataUser.department,
          label: props.rowDataUser.department,
        }
      : ""
  );

  const [divisionArr, setDivisionArr] = useState([]);

  const [changeType, setChangeType] = useState(
    props.rowDataUser && props.rowDataUser.changeType
      ? {
          value: props.rowDataUser.changeType,
          label: props.rowDataUser.changeType,
        }
      : ""
  );

  const [driverTypeArr, setDriverTypeArr] = useState([]);

  const [truckTypeArr, setTruckTypeArr] = useState([]);

  const truckTypeArrLocal = useSelector((state) => state.truck.getTruckData);

  const driverNameArrLocal = useSelector((state) => state.driver.getdriverData);

  const [doorToArray, setdoorToArray] = useState([]);

  const [trailerIdArray, setTrailerIdArray] = useState([]);

  const [loginResponse, setLoginResponse] = useState(null);

  const [trailerId, setTrailerId] = useState(
    props.rowDataUser && props.rowDataUser.trailer
      ? {
          value: props.rowDataUser?.trailer?.id,
          label: props.rowDataUser?.trailer?.btId,
        }
      : ""
  );

  const [currentLocation, setCurrentLocation] = useState(
    props.rowDataUser && props.rowDataUser.trailer
      ? props.rowDataUser.trailer.currentLocation
      : ""
  );

  const [isTrailerContainerChecked, setIsTrailerContainerChecked] =
    useState(false);

  const [isUpdateMove, setIsUpdate] = useState(false);

  const [lotFrom, setLotFrom] = useState("");

  const [lotTo, setLotTo] = useState("");

  const [YardFromArr, setYardFromArr] = useState([]);
  const [lotToArr, setLotToArray] = useState([]);
  const [divisionTo, setDivisionTo] = useState("");
  const [divisionDC2DCArr, setDivisionDC2DCArr] = useState([]);

  const [goingToArr, setGoingToArray] = useState([]);
  const [spaceFrom, setSpaceFrom] = useState([]);

  const [spaceToArr, setSpaceToArray] = useState([]);
  const [spaceTo, setSpaceTo] = useState([]);

  const [locationFrom, setLocationFrom] = useState("");
  const [locationTo, setLocationTo] = useState("");
  const [locationArr, setLocationArray] = useState([]);

  const [priorityMove, setIsPriorityMove] = useState(false);

  const [activeUsers, setActiveUsers] = useState([]);

  const [changeTypeArr, setChangeTypeArr] = useState([
    { label: "In-Coming", value: "OFFSITE_INCOMING" },
    { label: "Out-Going", value: "OFFSITE_OUTGOING" },
    { label: "OffSite-To-OffSite", value: "OFFSITE" },
    { label: "DC-To-DC", value: "DC2DC" },
  ]);

  let rowDataDivision = useSelector((state) => state.division.getDivisionData);

  rowDataDivision = rowDataDivision.filter((data, i) => {
    return data?.is_active === true;
  });

  const rowDataLot = useSelector((state) => state.lots.getLotData);

  const rowDataDoorForMove = useSelector((state) => state.doors.getDoorForMove);

  const rowDataTrailer = useSelector(
    (state) => state.trailerManagement.getTrailerData
  );

  const rowLocationArray = useSelector(
    (state) => state.location.getLocationData
  );

  const rowSpaceToArray = useSelector((state) => state.move.getSpaceToData);

  const rowDataRuralLog = useSelector(
    (state) => state.ruralTrailer.getRuralTrailerLogsData
  );

  const rowActiveDataUser = useSelector(
    (state) => state.userManagement.getActiveUserData
  );

  const rowDataDepartmentTemp = useSelector(
    (state) => state.department.getDepartmentData
  );
  const [departmentTypeArr, setDepartmentTypeArr] = useState([]);

  let divisionsArrayTemp = useSelector(
    (state) => state.division.getDivisionData
  );
  divisionsArrayTemp = divisionsArrayTemp.filter((data, i) => {
    return data?.is_active === true;
  });
  const divisionSelectedTemp = useSelector(
    (state) => state.division.divisionSelected
  );

  const [reasonForCancellation, setReasonForCancellation] = useState({
    label: "No Issue",
    value: "No Issue",
  });

  const [reasonCancellationArr, setReasonCancellationArr] = useState([
    { label: "No Issue", value: "No Issue" },
    { label: "Cancelled By Hanes", value: "Cancelled By Hanes" },
    { label: "Incorrect Input", value: "Incorrect Input" },
    { label: "Red Light", value: "Red Light" },
    { label: "Trailer Issue", value: "Trailer Issue" },
    { label: "Wrong Space", value: "Wrong Space" },
  ]);

  let comingFromArray = [
    {
      label: "Door",
      value: "DOOR",
    },
    {
      label: "Space",
      value: "SPACE",
    },
  ];

  let goingToArray = [
    {
      label: "Door",
      value: "DOOR",
    },
    {
      label: "Space",
      value: "SPACE",
    },
    {
      label: "Yard",
      value: "YARD",
    },
  ];

  useEffect(() => {
    if (rowActiveDataUser?.length > 0 && rowActiveDataUser != "Failed") {
      var data = [];
      for (var i = 0; i < rowActiveDataUser.length; i++) {
        data.push({
          value: rowActiveDataUser[i]?.user_id,
          label:
            (rowActiveDataUser[i]?.firstName != undefined
              ? rowActiveDataUser[i]?.firstName
              : "") +
            " " +
            (rowActiveDataUser[i]?.lastName != undefined
              ? rowActiveDataUser[i]?.lastName
              : ""),
        });
      }
      setActiveUsers(data);
    }
  }, [rowActiveDataUser]);

  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let name = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)?.user?.firstName
          : ""
        : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }
  }, []);

  useEffect(() => {
    setChangeTypeArr(changeTypeArr);

    setGoingToArray(goingToArray);
    if (requesterName != "" && requesterName != null && userId != null) {
      setRequesterName({
        label: props.rowDataUser?.requesterName,
        value: props.rowDataUser?.user_id,
      });
    } else {
      let localstorageLR = localStorage.getItem("L_R");
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let name = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)?.user?.firstName
          : ""
        : "";
      let userId = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)?.user?.user_id
          : ""
        : "";

      setRequesterName({ label: name, value: userId });
    }

    //division
    if (props.rowDataUser?.division != null && rowDataDivision.length > 0) {
      let divisionArr = rowDataDivision.filter(
        (item) => item.division_id == props.rowDataUser.division.division_id
      );
      if (divisionArr.length > 0) {
        setDivision({
          label: divisionArr[0].divisionName,
          value: divisionArr[0].division_id,
        });
      }
    }

    if (props.rowDataUser?.divisionToId != null && rowDataDivision.length > 0) {
      let divisionArr = rowDataDivision.filter(
        (item) => item.division_id == props.rowDataUser?.divisionTo?.division_id
      );
      if (divisionArr.length > 0) {
        setDivisionTo({
          label: divisionArr[0].divisionName,
          value: divisionArr[0].division_id,
        });
      }
      let data = [];

      if (props.rowDataUser?.division != null) {
        for (var i = 0; i < rowDataDivision.length; i++) {
          if (
            rowDataDivision[i].division_id ==
            props.rowDataUser?.division?.division_id
          ) {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: true,
            });
          } else {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
          }
        }
      }
      setDivisionDC2DCArr(data);
    }

    if (truckTypeArrLocal && truckTypeArrLocal.length > 0) {
      var data = [];
      for (var i = 0; i < truckTypeArrLocal.length; i++) {
        if (
          truckTypeArrLocal[i].is_active === true &&
          truckTypeArrLocal[i].division.division_id ===
            divisionSelectedTemp?.value
        ) {
          data.push({
            label: truckTypeArrLocal[i].type + "_" + truckTypeArrLocal[i].bt_id,
            value: truckTypeArrLocal[i].truck_id,
          });
        }
      }
      setTruckTypeArr(data);
    }

    if (driverNameArrLocal && driverNameArrLocal.length > 0) {
      var data = [];
      for (var i = 0; i < driverNameArrLocal.length; i++) {
        if (driverNameArrLocal[i].is_active) {
          data.push({
            label:
              driverNameArrLocal[i]?.firstName +
              " " +
              driverNameArrLocal[i]?.lastName,
            value: driverNameArrLocal[i]?.user_id,
          });
        }
      }
      setDriverTypeArr(data);
    }

    if (divisionsArrayTemp) {
      var data = [],
        dataDC2DC = [];
      if (props.rowDataUser && props.rowDataUser?.division_id != null) {
        let divisionTemp = divisionsArrayTemp.filter((obj) => {
          return obj?.division_id == props.rowDataUser?.division?.division_id;
        });
        setDivision({
          value: divisionTemp[0]?.division_id,
          label: divisionTemp[0]?.divisionName,
        });
        for (var i = 0; i < divisionsArrayTemp.length; i++) {
          if (
            divisionsArrayTemp[i].division_id ==
            props.rowDataUser?.division?.division_id
          ) {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
          } else {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: true,
            });
          }
        }
        setDivisionArr(data);

        for (var i = 0; i < divisionsArrayTemp.length; i++) {
          if (divisionsArrayTemp[i].division_id == divisionSelectedTemp.value) {
            dataDC2DC.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: true,
            });
          } else {
            dataDC2DC.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
          }
        }
        setDivisionDC2DCArr(dataDC2DC);
      } else if (
        divisionSelectedTemp &&
        divisionSelectedTemp != null &&
        divisionSelectedTemp != ""
      ) {
        for (var i = 0; i < divisionsArrayTemp.length; i++) {
          if (divisionsArrayTemp[i].division_id == divisionSelectedTemp.value) {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
          } else {
            data.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: true,
            });
          }
        }
        for (var i = 0; i < divisionsArrayTemp.length; i++) {
          if (divisionsArrayTemp[i].division_id == divisionSelectedTemp.value) {
            dataDC2DC.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: true,
            });
          } else {
            dataDC2DC.push({
              label: divisionsArrayTemp[i].divisionName,
              value: divisionsArrayTemp[i].division_id,
              isdisabled: false,
            });
          }
        }
        setDivisionDC2DCArr(dataDC2DC);
        setDivisionArr(data);
        setDivision({
          value: divisionSelectedTemp?.value,
          label: divisionSelectedTemp?.label,
        });
      } else {
        for (var i = 0; i < divisionsArrayTemp.length; i++) {
          data.push({
            label: divisionsArrayTemp[i].divisionName,
            value: divisionsArrayTemp[i].division_id,
          });
        }
        setDivisionArr(data);
      }
    } else {
      if (rowDataDivision && rowDataDivision.length > 0) {
        var data = [];
        for (var i = 0; i < rowDataDivision.length; i++) {
          data.push({
            label: rowDataDivision[i].divisionName,
            value: rowDataDivision[i].division_id,
          });
        }
        setDivisionArr(data);
      }
      setDivision({
        value: divisionSelectedTemp.value,
        label: divisionSelectedTemp.label,
      });
    }
    //Door
    if (props.rowDataUser?.doorToId != null && rowDataDoorForMove.length > 0) {
      let doorArr = rowDataDoorForMove.filter(
        (item) => item.door_id == props.rowDataUser.doorTo.door_id
      );
      let trailerValue =
        doorArr[0].currentOccupancy != null
          ? "_TRAILER"
          : doorArr[0].outsideCarrierContainer_id != null
          ? "_CONTAINER"
          : "_EMPTY";

      if (doorArr.length > 0) {
        setDoorTo({
          label:
            doorArr[0].doorType + "_" + doorArr[0].number + "_" + trailerValue,
          value: doorArr[0].door_id,
        });
      }
      setGoingTo({ value: "DOOR", label: "Door" });
      setGoingToArray(goingToArray);
    }

    //Trailer
    if (rowDataTrailer && rowDataTrailer.length > 0) {
      var data = [];

      if (trailerId && trailerId?.value) {
        let obj = {
          id: trailerId?.value,
        };
        dispatch({
          type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
            .GET_RURAL_TRAILER_LOGS_API_CALL,
          payload: { value: obj },
        });
      }

      for (var i = 0; i < rowDataTrailer.length; i++) {
        data.push({
          label: rowDataTrailer[i].btId,
          value: rowDataTrailer[i].id,
          currentLoad: rowDataTrailer[i]?.currentLoad,
        });
      }
      setTrailerIdArray(data);
    }

    if (
      props.rowDataUser?.changeType != "" &&
      props.rowDataUser?.changeType != null
    ) {
      let changeType = changeTypeArr.filter(
        (item) => item.value == props.rowDataUser.changeType
      );

      setChangeType(changeType[0]);
    }

    if (rowDataLot?.length > 0) {
      if (props.rowDataUser?.lotToId != null) {
        let lotArray = rowDataLot?.filter(
          (item) => item.lot_id == props.rowDataUser.lotToId
        );
        setLotTo({
          label: lotArray[0].lotName,
          value: lotArray[0].lot_id,
          spaces: lotArray[0].spaces,
          division_id: lotArray[0].division_id,
          divisionName: lotArray[0].division.divisionName,
        });

        let lotDivisionArray = rowDataLot?.filter(
          (item) => parseInt(item.division_id) === parseInt(division?.value)
        );

        let data = [];
        for (var i = 0; i < lotDivisionArray.length; i++) {
          data.push({
            label: lotDivisionArray[i].lotName,
            value: lotDivisionArray[i].lot_id,
            spaces: lotDivisionArray[i].spaces,
            division_id: lotDivisionArray[i].division_id,
            divisionName: lotDivisionArray[i].divisionName,
          });
        }
        setLotToArray(data);
        setYardFromArr(data);
        setGoingToArray(goingToArray);
        if (props.rowDataUser?.spaceTo == null) {
          setGoingTo({ label: "Yard", value: "YARD" });
        }
      }
      if (props.rowDataUser?.lotFromId != null) {
        //get lot
        let lotArray = rowDataLot?.filter(
          (item) => item.lot_id == props.rowDataUser.lotFromId
        );
        setLotFrom({
          label: lotArray[0].lotName,
          value: lotArray[0].lot_id,
          spaces: lotArray[0].spaces,
          division_id: lotArray[0].division_id,
          divisionName: lotArray[0].division.divisionName,
        });

        let lotDivisionArray = rowDataLot?.filter(
          (item) => item.division_id == division?.value
        );
        let data = [];
        for (var i = 0; i < lotDivisionArray.length; i++) {
          data.push({
            label: lotDivisionArray[i].lotName,
            value: lotDivisionArray[i].lot_id,
            spaces: lotDivisionArray[i].spaces,
            division_id: lotDivisionArray[i].division_id,
            divisionName: lotDivisionArray[i].divisionName,
          });
        }
        setYardFromArr(data);
      } else {
        let data = [];
        let lotDivisionArray = rowDataLot?.filter(
          (item) =>
            parseInt(item.division_id) == parseInt(division?.division_id)
        );
        for (var i = 0; i < lotDivisionArray?.length; i++) {
          data.push({
            label: lotDivisionArray[i].lotName,
            value: lotDivisionArray[i].lot_id,
            spaces: lotDivisionArray[i].spaces,
            division_id: lotDivisionArray[i].division_id,
            divisionName: lotDivisionArray[i].division.divisionName,
          });
        }
        setLotToArray(data);
        setYardFromArr(data);
      }
    }

    if (rowSpaceToArray?.length > 0) {
      if (props.rowDataUser?.spaceTo != null) {
        //get lot
        let spaceArray = rowSpaceToArray.filter(
          (item) => item?.space_id == props.rowDataUser?.spaceToId
        );
        setSpaceTo({
          label: spaceArray[0]?.btId,
          value: spaceArray[0]?.space_id,
        });

        let spaceLotArray = rowSpaceToArray.filter(
          (item) => item.lot_id == props.rowDataUser?.lotToId
        );
        let data = [];
        for (var i = 0; i < spaceLotArray.length; i++) {
          data.push({
            label: spaceLotArray[i]?.btId,
            value: spaceLotArray[i]?.space_id,
          });
        }
        setSpaceToArray(data);
        setGoingTo({ value: "SPACE", label: "Space" });
        setGoingToArray(goingToArray);
      } else {
        let data = [];
        for (var i = 0; i < rowSpaceToArray?.length; i++) {
          data.push({
            label: rowSpaceToArray[i]?.btId,
            value: rowSpaceToArray[i]?.space_id,
          });
        }
        setSpaceToArray(data);
      }
    }

    if (division && division != null) {
      if (changeType?.value == "OFFSITE_INCOMING") {
        if (rowDataDoorForMove && rowDataDoorForMove.length > 0) {
          var data = [];
          let doorForMoveArray = rowDataDoorForMove.filter(
            (item) => item.division_id == division?.division_id
          );
          for (var i = 0; i < doorForMoveArray.length; i++) {
            data.push({
              label:
                doorForMoveArray[i].doorType +
                "_" +
                doorForMoveArray[i].number +
                "_" +
                (doorForMoveArray[i].btId ? doorForMoveArray[i].btId : "EMPTY"),
              value: doorForMoveArray[i].door_id
                ? doorForMoveArray[i].door_id
                : "EMPTY",
              isdisabled: doorForMoveArray[i].btId != null ? true : false,
            });
          }

          setdoorToArray(data);
        }
      }
    }

    if (
      props.rowDataUser?.locationToId != null &&
      props.rowDataUser?.locationToId != ""
    ) {
      dispatch({
        type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT.GET_LOCATION_API_CALL,
        payload: { value: { bydivision: true } },
      });
    }

    if (
      props.rowDataUser?.department &&
      props.rowDataUser?.department != "" &&
      props.rowDataUser?.department != null
    ) {
      let department = rowDataDepartmentTemp.filter(
        (item) => item.departmentName == props.rowDataUser.department
      );
      setDepartmentType({
        value: department[0]?.departmentName,
        label: department[0]?.departmentName,
      });
      setDepartment({
        value: department[0]?.departmentName,
        label: department[0]?.departmentName,
      });
    }
  }, []);

  useEffect(() => {
    if (
      rowDataDepartmentTemp &&
      rowDataDepartmentTemp.length > 0 &&
      rowDataDepartmentTemp != "Failed"
    ) {
      let activeDepartmentData = rowDataDepartmentTemp.filter(
        (item) => item.is_active == true
      );
      var data = [];
      for (var i = 0; i < activeDepartmentData.length; i++) {
        data.push({
          value: activeDepartmentData[i]?.departmentName,
          label: activeDepartmentData[i]?.departmentName,
        });
      }
      setDepartmentTypeArr(data);
    }
  }, [rowDataDepartmentTemp]);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_DOOR_FOR_MOVES_API_CALL,
    });
  }, [division != "null" && division != ""]);

  useEffect(() => {
    if (rowDataDoorForMove && rowDataDoorForMove.length > 0) {
      var data = [];
      let doorForMoveArray = rowDataDoorForMove.filter(
        (item) => item.division_id == division?.value
      );
      for (var i = 0; i < doorForMoveArray.length; i++) {
        let trailerValue =
          doorForMoveArray[i].currentOccupancy != null
            ? "_TRAILER"
            : doorForMoveArray[i].outsideCarrierContainer_id != null
            ? "_CONTAINER"
            : "_EMPTY";
        data.push({
          label:
            doorForMoveArray[i].doorType +
            "_" +
            doorForMoveArray[i].number +
            trailerValue,
          value: doorForMoveArray[i].door_id,
        });
      }
      setdoorToArray(data);
    }
  }, [goingTo?.value == "DOOR"]);

  useEffect(() => {
    if (rowDataLot?.length > 0) {
      if (props.rowDataUser?.lotToId != null) {
        //get lot
        let lotArray = rowDataLot?.filter(
          (item) => item.lot_id == props.rowDataUser.lotToId
        );
        setLotTo({
          label: lotArray[0].lotName,
          value: lotArray[0].lot_id,
          spaces: lotArray[0].spaces,
          division_id: lotArray[0].division_id,
          divisionName: lotArray[0].division.divisionName,
        });

        let lotDivisionArray = rowDataLot?.filter(
          (item) => parseInt(item.division_id) == parseInt(division?.value)
        );

        let data = [];
        for (var i = 0; i < lotDivisionArray.length; i++) {
          data.push({
            label: lotDivisionArray[i].lotName,
            value: lotDivisionArray[i].lot_id,
            spaces: lotDivisionArray[i].spaces,
            division_id: lotDivisionArray[i].division_id,
            divisionName: lotDivisionArray[i].divisionName,
          });
        }
        setLotToArray(data);
        setYardFromArr(data);
        setGoingToArray(goingToArray);
      }
      if (props.rowDataUser?.lotFromId != null) {
        //get lot
        let lotArray = rowDataLot?.filter(
          (item) => item.lot_id == props.rowDataUser.lotFromId
        );
        setLotFrom({
          label: lotArray[0].lotName,
          value: lotArray[0].lot_id,
          spaces: lotArray[0].spaces,
          division_id: lotArray[0].division_id,
          divisionName: lotArray[0].division.divisionName,
        });

        let lotDivisionArray = rowDataLot?.filter(
          (item) => item.division_id == division?.value
        );
        let data = [];
        for (var i = 0; i < lotDivisionArray.length; i++) {
          data.push({
            label: lotDivisionArray[i].lotName,
            value: lotDivisionArray[i].lot_id,
            spaces: lotDivisionArray[i].spaces,
            division_id: lotDivisionArray[i].division_id,
            divisionName: lotDivisionArray[i].divisionName,
          });
        }
        setYardFromArr(data);
      } else {
        let data = [];
        let lotDivisionArray = rowDataLot?.filter(
          (item) => parseInt(item.division_id) == parseInt(division?.value)
        );
        for (var i = 0; i < lotDivisionArray?.length; i++) {
          data.push({
            label: lotDivisionArray[i].lotName,
            value: lotDivisionArray[i].lot_id,
            spaces: lotDivisionArray[i].spaces,
            division_id: lotDivisionArray[i].division_id,
            divisionName: lotDivisionArray[i].division.divisionName,
          });
        }
        setLotToArray(data);
        setYardFromArr(data);
      }
    }
  }, [goingTo?.value == "SPACE" || goingTo?.value == "YARD"]);

  useEffect(() => {
    if (trailerId && trailerId?.value) {
      let obj = {
        id: trailerId?.value,
      };
      dispatch({
        type: CONSTANTS.CONSTANTS_RURAL_TRAILERS_MANAGEMENT
          .GET_RURAL_TRAILER_LOGS_API_CALL,
        payload: { value: obj },
      });
    }
  }, [trailerId]);

  useEffect(() => {
    if (trailerId !== null && trailerId !== "" && rowDataRuralLog?.length > 0) {
      var sortedDoorLog = rowDataRuralLog.sort(function (a, b) {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
      if (sortedDoorLog.length > 0) {
        let spaceOccupant = sortedDoorLog[0].currDoor?.door_id
          ? sortedDoorLog[0].currDoor.doorType +
            "_" +
            sortedDoorLog[0].currDoor.number
          : sortedDoorLog[0]?.currSpace && sortedDoorLog[0].currSpace.btId
          ? sortedDoorLog[0].currSpace.lot?.lotName +
            "_" +
            sortedDoorLog[0].currSpace.btId
          : sortedDoorLog[0]?.currentLocation
          ? sortedDoorLog[0].currentLocation
          : "UNKNOWN";
        setCurrentLocation(
          (division?.label ? division.label + "_" : "") +
            (spaceOccupant || "UNKNOWN")
        );
        if (sortedDoorLog[0]?.currSpace && sortedDoorLog[0]?.currSpace?.btId) {
          setSpaceFrom({
            label:
              sortedDoorLog[0].currSpace.lot?.lotName +
              "_" +
              sortedDoorLog[0].currSpace?.btId,
            value: sortedDoorLog[0].currSpace?.space_id,
          });
        } else if (
          sortedDoorLog[0]?.currDoor &&
          sortedDoorLog[0]?.currDoor?.door_id !== null
        ) {
          setDoorFrom({
            label:
              sortedDoorLog[0]?.currDoor?.doorType +
              "_" +
              sortedDoorLog[0]?.currDoor?.number,
            value: sortedDoorLog[0]?.currDoor?.door_id,
          });
        }
      }
    }
  }, [rowDataRuralLog]);

  useEffect(() => {
    if (rowLocationArray.length > 0) {
      let data = [];
      for (var i = 0; i < rowLocationArray.length; i++) {
        data.push({
          label: rowLocationArray[i].name,
          value: rowLocationArray[i].location_id,
        });
      }
      if (
        props.rowDataUser?.locationToId != null &&
        props.rowDataUser?.locationToId != ""
      ) {
        let location = data.filter(
          (item) => item.value == props.rowDataUser?.locationToId
        );
        setLocationTo(location[0]);
      }
      setLocationArray(data);
    }
  }, [rowLocationArray]);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_TO_API_CALL,
    });

    dispatch({
      type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT.GET_SPACE_FROM_API_CALL,
    });
  }, [goingTo?.value == "SPACE" && lotTo != ""]);

  useEffect(() => {
    if (rowSpaceToArray && rowSpaceToArray.length > 0) {
      let spaceToArrTemp = rowSpaceToArray.filter(
        (item) => item.lot_id == lotTo?.value
      );
      if (spaceToArrTemp.length > 0) {
        let data = [];
        for (var i = 0; i < spaceToArrTemp.length; i++) {
          data.push({
            label:
              spaceToArrTemp[i]?.btId +
              "_" +
              (spaceToArrTemp[i]?.trailerBtId
                ? spaceToArrTemp[i]?.trailerBtId
                : "EMPTY"),
            value: spaceToArrTemp[i].space_id,
            trailerBtId: spaceToArrTemp[i]?.trailerBtId
              ? spaceToArrTemp[i]?.trailerBtId
              : "",
            trailerId: spaceToArrTemp[i]?.trailer_id
              ? spaceToArrTemp[i]?.trailer_id
              : null,
          });
        }
        if (
          props.rowDataUser?.spaceToId != null &&
          props.rowDataUser?.spaceTo != null
        ) {
          let spaceToTemp = spaceToArrTemp.filter(
            (item) => item.space_id == props.rowDataUser?.spaceTo?.space_id
          );
          if (spaceToTemp.length == 0) {
            setSpaceTo({
              label: props.rowDataUser.spaceTo?.btId + "_" + "EMPTY",
              value: props.rowDataUser.spaceTo?.space_id,
              trailerBtId: "",
              trailerId: null,
              isDisabled: true,
            });
          } else {
            setSpaceTo({
              label:
                spaceToTemp[0]?.btId +
                "_" +
                (spaceToTemp[0]?.trailerBtId
                  ? spaceToTemp[0]?.trailerBtId
                  : "EMPTY"),
              value: spaceToTemp[0]?.space_id,
              trailerBtId: spaceToTemp[0]?.trailerBtId
                ? spaceToTemp[0]?.trailerBtId
                : "",
              trailerId: spaceToTemp[0]?.trailer_id
                ? spaceToTemp[0]?.trailer_id
                : null,
            });
          }
        }
        setSpaceToArray(data);
      }
    }
  }, [rowSpaceToArray]);

  const formatAMPM = (date) => {
    // This is to display 12 hour format like you asked
    var hours = date.getHours();
    var minutes = date.getMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes;
    return strTime;
  };

  function dateDiffCalc(milliseconds) {
    let secs = Math.floor(Math.abs(milliseconds) / 1000);
    let mins = Math.floor(secs / 60);
    let hours = Math.floor(mins / 60);
    const millisecs = Math.floor(Math.abs(milliseconds)) % 1000;

    return {
      days: hours + " ",
      hours: " :" + (hours % 24) + " ,",
      minutes: " :" + (mins % 60) + " ,",
      seconds: " " + (secs % 60) + " ",
      milliSeconds: " " + millisecs + " ",
    };
  }

  useEffect(() => {
    let myDate = requestTime ? new Date(requestTime) : new Date();
    let dateTimeFormat =
      myDate.getMonth() +
      1 +
      "/" +
      myDate.getDate() +
      "/" +
      myDate.getFullYear() +
      " " +
      formatAMPM(myDate);
    setRequestTime(dateTimeFormat);
  }, []);

  return (
    <Modal
      size="lg"
      show={props.isShow}
      onHide={props.handleClose}
      backdrop="static"
      centered
      keyboard={false}
    >
      <Modal.Header style={{ backgroundColor: "rgb(0, 42, 74)" }}>
        <Modal.Title style={{ fontFamily: "Roboto", color: "white" }}>
          {props.title ? props.title : "Create New Offsite Request"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div
          className="row container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "space-between",
          }}
        >
          <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
            <div>
              <label style={{ fontSize: 14 }}>
                {props.keyData == "InProgressRequest"
                  ? "Request Start Time"
                  : "Request Time"}
              </label>
            </div>

            <DateTimePicker
              className="dateTimePicker"
              value={requestTime}
              disabled={true}
            />
          </div>

          <div className="col-12 col-md-12 col-sm-12 col-lg-1 mb-2" />
          {props.keyData == "InProgressRequest" ? (
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
              <div>
                <label style={{ fontSize: 14 }}>{"Request Finish Time"}</label>
              </div>

              <div>
                <DateTimePicker
                  className="d-flex"
                  value={requestFinishTime}
                  onChange={(requestFinishTime) => {
                    setTotalTime();
                    let myDate = new Date(requestFinishTime);
                    setRequestFinishTime(myDate);
                    let milliSeconds =
                      myDate - new Date(props.rowDataUser?.startDateTime);
                    let totalTime = dateDiffCalc(milliSeconds);
                    setTotalTime(totalTime);
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
              <div>
                <label style={{ fontSize: 14 }}>Requester Name</label>
              </div>

              <div>
                <DropDownComp
                  style={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Requester"}
                  options={activeUsers}
                  onChange={(value) => {
                    setRequesterName(value);
                    dispatch({
                      type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                        .GET_CONTAINERS_API_CALL,
                    });
                  }}
                  value={requesterName}
                />
              </div>
            </div>
          )}
        </div>

        <div
          className="row container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "space-between",
          }}
        >
          <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
            <div>
              <label style={{ fontSize: 14 }}> {"Department"}</label>
            </div>

            <div>
              <DropDownComp
                Q={{
                  height: 35,
                  display: "flex",
                  flexDirection: "row",
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  fontSize: 14,
                }}
                name={"Department Type"}
                options={departmentTypeArr}
                onChange={(value) => {
                  setDepartment(value);
                  setrowDataValue((previos) => ({
                    ...previos,
                    departmentType: value,
                  }));
                }}
                value={department}
              />
            </div>
          </div>

          <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
            <div>
              <label style={{ fontSize: 14 }}>Change Type </label>
            </div>

            <div>
              <DropDownComp
                styles={{
                  height: 35,
                  display: "flex",
                  flexDirection: "row",
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  fontSize: 14,
                }}
                name={"Change Type"}
                options={changeTypeArr}
                onChange={(value) => {
                  setChangeType(value);
                  setTrailerId("");
                  setGoingTo("");
                  setDoorTo("");
                  setSpaceTo("");
                  if (
                    value?.value == "OFFSITE_OUTGOING" ||
                    value?.value == "OFFSITE"
                  ) {
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOCATION_MANAGEMENT
                        .GET_LOCATION_API_CALL,
                      payload: { value: { bydivision: true } },
                    });
                  }
                  setrowDataValue((previos) => ({
                    ...previos,
                    changeType: value,
                  }));
                }}
                value={changeType}
              />
            </div>
          </div>

          {changeType && changeType != null ? (
            <>
              <div className="container ">
                <div
                  style={{ display: "flex", justifyContent: "space-evenly" }}
                >
                  <label className="ml-10" style={{ fontSize: 14 }}>
                    <input
                      type="radio"
                      checked={isTrailer}
                      onClick={() => {
                        setIsTrailer(true);
                        setIsContainer(false);
                        setContainerId("");
                      }}
                      value="Trailer"
                    />
                    Trailer
                  </label>

                  <label style={{ fontSize: 14 }}>
                    <input
                      type="radio"
                      checked={isContainer}
                      onClick={() => {
                        setIsTrailer(false);
                        setIsContainer(true);
                        setTrailerId("");
                      }}
                      value="Container"
                    />{" "}
                    Container
                  </label>
                  <div />
                </div>
              </div>
              {isTrailer && (
                <>
                  <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                    <div>
                      <label style={{ fontSize: 14 }}>Trailer Id Search</label>
                    </div>

                    <div>
                      <DropDownComp
                        styles={{
                          height: 35,
                          display: "flex",
                          flexDirection: "row",
                          borderColor: "hsl(0, 0%, 50%)",
                          borderStyle: "solid",
                          borderWidth: "1px",
                          fontSize: 14,
                        }}
                        name={"Trailer Id"}
                        options={trailerIdArray}
                        isDisabled={
                          isTrailerContainerChecked ||
                          (moveType && moveType.value == "Door Out")
                            ? true
                            : false
                        }
                        onChange={(value) => {
                          setTrailerId(value);
                          setPreviousLoadVolume({
                            value: value.currentLoad,
                            label: value.currentLoad,
                          });
                          setNewLoadVolume({
                            value: value.currentLoad,
                            label: value.currentLoad,
                          });
                        }}
                        value={trailerId}
                      />
                    </div>
                  </div>
                </>
              )}

              {isContainer && (
                <>
                  <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                    <div>
                      <label style={{ fontSize: 14 }}>Container</label>
                    </div>
                    <div className="row wrapper col-12 col-md-12 p-0 col-sm-12 col-lg-12 ">
                      <div
                        style={{
                          display: "flex",
                          padding: 0,
                          margin: 0,
                          flexDirection: "row",
                        }}
                        className={"row col-10 col-md-10 col-sm-10 col-lg-10"}
                      >
                        <CreatableSelect
                          isClearable={false}
                          className="Containerclass"
                          allowCreateWhileLoading={false}
                          ref={creatableInputRef}
                          onChange={(val) => {
                            setContainerId(val);
                          }}
                          // onInputChange={(newTextValue, actionMeta) => {
                          //     setContainerId(newTextValue);
                          // }}
                          placeholder={"Select Container"}
                          options={containerIdArray}
                          value={containerId}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          borderRadius: 4,
                          borderWidth: 2,
                          borderColor: "#D3D3D3",
                        }}
                        className="col-2 col-md-2 p-0 col-sm-2 col-lg-2 "
                      >
                        {containerId &&
                        containerId != "" &&
                        containerId?.value != "" ? (
                          <img
                            onClick={() => {
                              if (
                                (moveType?.value == "DOOROUT" ||
                                  (moveType?.value == "DOOR2DOOR" &&
                                    doorFrom != null)) &&
                                containerId?.value != "" &&
                                containerId?.value != null
                              ) {
                                alert(
                                  "Container  already in Selected ,you cannot choose another Container"
                                );
                              } else {
                                setContainerId("");
                                setContainerIdArray([]);
                                setCreateContainerEnable(false);
                              }
                            }}
                            src={require("./../assets/Dashboard/clear1.png")}
                            style={{ width: 12, marginRight: 10, height: 12 }}
                            alt="test"
                          ></img>
                        ) : null}
                        {createContainerEnable && containerId != "" ? (
                          <img
                            alt="test"
                            onClick={() => {
                              let obj = {
                                btId: containerId?.value,
                                is_active: true,
                              };
                              dispatch({
                                type: CONSTANTS.CONSTANTS_MOVES_MANAGEMENT
                                  .CREATE_CONTAINER_API_CALL,
                                payload: { value: obj },
                              });
                              setCreateContainerEnable(false);
                            }}
                            src={require("./../assets/Dashboard/plus.png")}
                            style={{
                              display: "flex",
                              alignItems: "flex-end",
                              justifyContent: "flex-end",
                              height: 20,
                              width: 20,
                            }}
                          ></img>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-end",
                              justifyContent: "flex-end",
                              height: 20,
                              width: 20,
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          ) : null}
        </div>

        {changeType && changeType?.value == "DC2DC" ? (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div className="col-12 col-md-12 col-sm-12 col-lg-4">
              <div>
                <label style={{ fontSize: 14 }}>{"Division"}</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Division"}
                  options={divisionArr}
                  onChange={(value) => {
                    setDivision(value);
                  }}
                  value={division}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4">
              <div>
                <label style={{ fontSize: 14 }}>Division To</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Division"}
                  options={divisionDC2DCArr}
                  onChange={(value) => {
                    setDivisionTo(value);
                  }}
                  value={divisionTo}
                />
              </div>
            </div>
          </div>
        ) : null}

        {changeType && changeType?.value != "DC2DC" ? (
          <div
            className="row container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "space-between",
            }}
          >
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}>Coming From </label>
              </div>
              <div>
                <InputComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Coming"}
                  placeholder={"Select Coming"}
                  labelName={"Select Coming"}
                  options={comingFromArray}
                  onChange={(value) => {
                    setComingFrom(value);
                  }}
                  isDisabled={true}
                  value={currentLocation}
                />
              </div>
            </div>

            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}>Going To </label>
              </div>
              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Going To"}
                  options={
                    changeType?.value == "OFFSITE_INCOMING"
                      ? goingToArr
                      : locationArr
                  }
                  isDisabled={changeType?.value == "YARD2YARD" ? true : false}
                  onChange={(value) => {
                    if (changeType?.value == "OFFSITE_INCOMING") {
                      setGoingTo(value);
                    } else {
                      setLocationTo(value);
                    }
                  }}
                  value={
                    changeType?.value == "OFFSITE_INCOMING"
                      ? goingTo
                      : locationTo
                  }
                />
              </div>
            </div>
          </div>
        ) : null}

        <div
          className="row container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "space-between",
          }}
        >
          {changeType?.value == "OFFSITE_INCOMING" &&
          goingTo?.value == "DOOR" ? (
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}> {"Door"}</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Door"}
                  options={doorToArray}
                  onChange={(value) => {
                    setDoorTo(value);
                  }}
                  value={doorTo}
                />
              </div>
            </div>
          ) : null}
          {changeType?.value == "OFFSITE_INCOMING" &&
          (goingTo?.value == "SPACE" || goingTo?.value == "YARD") ? (
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}> {"Yard"}</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Yard TO"}
                  isDisabled={false}
                  options={lotToArr}
                  onChange={(value) => {
                    setLotTo(value);
                    setSpaceTo("");
                  }}
                  value={lotTo}
                />
              </div>
            </div>
          ) : null}
          {changeType?.value == "OFFSITE_INCOMING" &&
          goingTo?.value == "SPACE" ? (
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}>{"Space"}</label>
              </div>
              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Space To"}
                  options={spaceToArr}
                  onChange={(value) => {
                    setSpaceTo(value);
                  }}
                  value={spaceTo}
                />
              </div>
            </div>
          ) : null}
        </div>

        <div
          className="row container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "space-between",
          }}
        >
          {changeType?.value == "YARD2YARD" ? (
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}> {"Yard From"}</label>
              </div>

              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Yard from"}
                  isDisabled={false}
                  options={YardFromArr}
                  onChange={(value) => {
                    setLotFrom(value);
                    let data = [];
                    for (let i = 0; i < YardFromArr.length; i++) {
                      if (YardFromArr[i].value == value.value) {
                        data.push({
                          label: YardFromArr[i]?.label,
                          value: YardFromArr[i]?.value,
                          spaces: YardFromArr[i].spaces,
                          division_id: YardFromArr[i].division_id,
                          divisionName: YardFromArr[i]?.divisionName,
                          isDisabled: true,
                        });
                      } else {
                        data.push({
                          label: YardFromArr[i]?.label,
                          value: YardFromArr[i]?.value,
                          spaces: YardFromArr[i]?.spaces,
                          division_id: YardFromArr[i]?.division_id,
                          divisionName: YardFromArr[i]?.divisionName,
                        });
                      }
                      setLotToArray(data);
                    }
                  }}
                  value={lotFrom}
                />
              </div>
            </div>
          ) : null}
          {changeType?.value == "YARD2YARD" ? (
            <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
              <div>
                <label style={{ fontSize: 14 }}> {"Yard To"}</label>
              </div>
              <div>
                <DropDownComp
                  styles={{
                    height: 35,
                    display: "flex",
                    flexDirection: "row",
                    borderColor: "hsl(0, 0%, 50%)",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    fontSize: 14,
                  }}
                  name={"Select Yard To"}
                  isDisabled={false}
                  options={lotToArr}
                  onChange={(value) => {
                    setLotTo(value);
                  }}
                  value={lotTo}
                />
              </div>
            </div>
          ) : null}
        </div>

        <div
          className="row container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "space-between",
          }}
        >
          <div className="col-12 col-md-12 col-sm-12 col-lg-4">
            <div>
              <label style={{ fontSize: 14 }}>Driver</label>
            </div>

            <div>
              <DropDownComp
                styles={{
                  height: 35,
                  display: "flex",
                  flexDirection: "row",
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  fontSize: 14,
                }}
                name={"Select Driver"}
                isDisabled={
                  loginResponse?.user?.userRoles[0]?.user_role_name ==
                  CONSTANTS.CONSTANTS_USER_ROLES.RHUSER
                    ? true
                    : false
                }
                options={driverTypeArr}
                onChange={(value) => {
                  setDriver(value);
                  setrowDataValue((previos) => ({ ...previos, driver: value }));
                }}
                value={driver}
              />
            </div>
          </div>

          <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
            <div>
              <label style={{ fontSize: 14 }}>Truck</label>
            </div>

            <div>
              <DropDownComp
                styles={{
                  height: 35,
                  display: "flex",
                  flexDirection: "row",
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  fontSize: 14,
                }}
                name={"Truck"}
                options={truckTypeArr}
                isDisabled={
                  loginResponse?.user?.userRoles[0]?.user_role_name ==
                  CONSTANTS.CONSTANTS_USER_ROLES.RHUSER
                    ? true
                    : false
                }
                onChange={(value) => {
                  setTruck(value);
                }}
                value={truck}
              />
            </div>
          </div>
        </div>

        <div
          className="row container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "space-between",
          }}
        >
          <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
            <div>
              <label style={{ fontSize: 14 }}>Seal Number</label>
            </div>

            <div>
              <InputComp
                style={{
                  height: "100%",
                  width: "100%",
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  padding: "8px",
                  fontSize: 14,
                }}
                labelName={"Seal Number"}
                maxLength={30}
                placeholder={"Seal Number"}
                value={sealNumber}
                onChangeHandler={(sealNumber) => {
                  setSealNumber(sealNumber);
                }}
              />
            </div>
          </div>

          <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
            <div>
              <label style={{ fontSize: 14 }}>Product Number</label>
            </div>

            <div>
              <InputComp
                style={{
                  height: "100%",
                  width: "100%",
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  padding: "8px",
                  fontSize: 14,
                }}
                labelName={"Product Number"}
                maxLength={30}
                placeholder={"Product Number"}
                value={productNumber}
                onChangeHandler={(productNumber) => {
                  setProductNumber(productNumber);
                }}
              />
            </div>
          </div>

          <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2 ">
            <div>
              <label style={{ fontSize: 14 }}>Actual Count</label>
            </div>
            <div>
              <InputComp
                style={{
                  height: "100%",
                  width: "100%",
                  borderColor: "hsl(0, 0%, 50%)",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  padding: "8px",
                  fontSize: 14,
                }}
                labelName={"Actual Count"}
                maxLength={30}
                placeholder={"Actual Count"}
                value={actualCount}
                onChangeHandler={(actualCount) => {
                  setActualCount(actualCount);
                }}
              />
            </div>
          </div>
        </div>

        <div
          className="row container d-flex mt-1 col-12 col-md-12 col-sm-12 col-lg-12"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <div
            className="row container d-flex col-12 col-md-12 col-sm-12 col-lg-6"
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            <div>
              <label style={{ fontSize: 14 }}> {"Notes"}</label>
            </div>
            <div>
              <InputComp
                style={{
                  height: "100%",
                  borderStyle: "solid",
                  borderWidth: "2px",
                  padding: "4px",
                  fontSize: 14,
                  borderColor: "hsl(0, 0%, 50%)",
                }}
                labelName={"Comments"}
                isMulti={true}
                placeholder={"Comments"}
                value={comment}
                onChangeHandler={(comment) => {
                  setComment(comment);
                }}
              />
            </div>
          </div>
        </div>

        {props.keyData == "InProgressRequest" ? (
          <view
            className="row container"
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
              height: "auto",
              width: "auto",
            }}
          >
            <div
              className="row col-4 col-md-4 col-4 col-sm-4 col-lg-4"
              style={{
                flex: 1,
              }}
            >
              <label style={{ fontSize: 14 }}>
                {" "}
                {"Reason for Cancellation  : "}
              </label>
            </div>
            <div className="row col-4 col-md-4 col-4 col-sm-4 col-lg-4">
              <DropDownComp
                styles={{
                  height: 35,
                  display: "flex",
                  flexDirection: "row",
                  fontSize: 14,
                }}
                name={"Select Reason"}
                options={reasonCancellationArr}
                onChange={(value) => {
                  setReasonForCancellation(value);
                }}
                value={reasonForCancellation}
              />
            </div>

            <div className="row col-4 col-md-4 col-4 col-sm-4 col-lg-4" />
          </view>
        ) : null}
      </Modal.Body>

      <Modal.Footer>
        <div
          className="row col-12 col-sm-12 col-md-12 col-lg-12"
          style={{ display: "flex", justifyContent: "space-around" }}
        >
          {loginResponse?.user?.userRoles[0]?.user_role_name !==
            CONSTANTS.CONSTANTS_USER_ROLES.RHUSER &&
          props.rowDataUser &&
          props.rowDataUser != null ? (
            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
              <button
                onClick={() => {
                  if (
                    driver == "" &&
                    requestTime == "" &&
                    changeType == "" &&
                    departmentType == "" &&
                    requesterName == "" &&
                    productNumber == "" &&
                    actualCount == "" &&
                    sealNumber == "" &&
                    comment == "" &&
                    truck == ""
                  ) {
                    alert("All Fields are compulsory");
                  } else if (changeType == "" || changeType == null) {
                    alert("Please Select Change Type");
                  } else if (
                    (changeType?.value == "OFFSITE_INCOMING" ||
                      changeType?.value == "DC2DC" ||
                      changeType?.value == "OFFSITE_OUTGOING") &&
                    sealNumber == ""
                  ) {
                    alert("Please Enter Seal Number");
                  } else {
                    try {
                      if (props.rowDataUser && props.rowDataUser != null) {
                        //update move
                        let payload = {
                          move_id: props.rowDataUser.move_id,
                          user_id: requesterName?.value, // change to number

                          division_id: division?.value,
                          changeType: changeType?.value, //Move type
                          requestDateTime: new Date(requestTime),
                          requesterName: requesterName?.label,
                          trailer_id: trailerId?.value ? trailerId.value : null,
                          outsideCarrierContainer_id:
                            containerId &&
                            containerId != "" &&
                            containerId != null
                              ? containerId?.value
                              : null,
                          doorToId: doorTo?.value ? doorTo?.value : null,
                          doorFromId: doorFrom?.value ? doorFrom?.value : null,
                          locationFromId: locationFrom?.value
                            ? locationFrom.value
                            : null,
                          locationToId: locationTo?.value
                            ? locationTo.value
                            : null,
                          spaceFromId:
                            spaceFrom != null ? spaceFrom?.value : null,
                          spaceToId: spaceTo != null ? spaceTo?.value : null,
                          department: department?.value
                            ? department?.value
                            : null,
                          productNum: productNumber,
                          actualCount: actualCount,
                          sealNum: sealNumber,
                          driver_id: driver?.value,
                          truck_id: truck?.value,
                          startDateTime: new Date(requestTime),
                          finishDateTime: new Date(),
                          beforeComments: comment,
                          afterComments:
                            props.keyData == "InProgressRequest"
                              ? afterComment
                              : "",
                          priorityMove: priorityMove, // true  false ,
                          completed: !props.isUpdate
                            ? props.keyData == "PendingRequest"
                              ? 0
                              : props.keyData == "InProgressRequest"
                              ? 1
                              : props.rowDataUser.completed
                            : props.rowDataUser.completed,
                          pending: !props.isUpdate
                            ? props.keyData == "PendingRequest"
                              ? 0
                              : props.keyData == "InProgressRequest"
                              ? 0
                              : props.rowDataUser.pending
                            : props.rowDataUser.pending,
                          requestFlag:
                            props.keyData == "InProgressRequest"
                              ? reasonForCancellation?.value
                              : "",
                          isEmpty:
                            trailerId != null
                              ? false
                              : isTrailerContainerChecked,
                          lotFromId: lotFrom?.value,
                          lotToId: lotTo?.value,
                          divisionToId: divisionTo?.value,
                          totalTime:
                            props.title == "Move to Complete Request"
                              ? Math.floor(
                                  (new Date() - new Date(requestTime)) / 60000
                                )
                              : null,
                          toDoor: goingTo?.value == "DOOR" ? "DOOR" : null, // door
                          toSpace: goingTo?.value == "SPACE" ? "SPACE" : null, // space
                          toYard: goingTo?.value == "YARD" ? "YARD" : null,
                          is_cancelled: false,
                        };
                        if (
                          props.keyTitle == moveTypeStatus.CompleteStatus &&
                          (trailerId?.value === "" ||
                            trailerId?.value === null ||
                            trailerId?.value === undefined) &&
                          (containerId?.value === "" ||
                            containerId?.value === null ||
                            containerId?.value === undefined)
                        ) {
                          alert("Please Select Trailer or container");
                        } else if (
                          (driver == null || driver == "") &&
                          (props.keyTitle == moveTypeStatus.InProgressStatus ||
                            props.keyTitle == moveTypeStatus.CompleteStatus ||
                            (props.keyTitle == moveTypeStatus.UpdateStatus &&
                              props.keyData == "InProgressRequest"))
                        ) {
                          alert("Please Select Driver");
                        } else if (changeType?.value == "OFFSITE_INCOMING") {
                          if (
                            (goingTo == null || goingTo == "") &&
                            (props.keyTitle ==
                              moveTypeStatus.InProgressStatus ||
                              props.keyTitle == moveTypeStatus.CompleteStatus ||
                              (props.keyTitle == moveTypeStatus.UpdateStatus &&
                                props.keyData == "InProgressRequest"))
                          ) {
                            alert("Please Select Going To");
                          } else if (
                            (doorTo == null || doorTo == "") &&
                            goingTo?.value?.toLowerCase() == "door" &&
                            (props.keyTitle ==
                              moveTypeStatus.InProgressStatus ||
                              props.keyTitle == moveTypeStatus.CompleteStatus ||
                              (props.keyTitle == moveTypeStatus.UpdateStatus &&
                                props.keyData == "InProgressRequest"))
                          ) {
                            alert("Please Select Door ");
                          } else if (
                            (lotTo == null || lotTo == "") &&
                            goingTo?.value?.toLowerCase() == "space" &&
                            (props.keyTitle ==
                              moveTypeStatus.InProgressStatus ||
                              props.keyTitle == moveTypeStatus.CompleteStatus ||
                              (props.keyTitle == moveTypeStatus.UpdateStatus &&
                                props.keyData == "InProgressRequest"))
                          ) {
                            alert("Please Select Yard ");
                          } else if (
                            (lotTo == null || lotTo == "") &&
                            goingTo?.value?.toLowerCase() == "yard" &&
                            (props.keyTitle ==
                              moveTypeStatus.InProgressStatus ||
                              props.keyTitle == moveTypeStatus.CompleteStatus ||
                              (props.keyTitle == moveTypeStatus.UpdateStatus &&
                                props.keyData == "InProgressRequest"))
                          ) {
                            alert("Please Select Yard ");
                          } else {
                            setCurrentLocation("");
                            props.setValue(payload);
                          }
                        } else if (changeType?.value == "DC2DC") {
                          if (
                            division == "" ||
                            division == null ||
                            division == undefined
                          ) {
                            alert("Please Select Division");
                          } else if (
                            trailerId?.value === "" ||
                            trailerId?.value === null ||
                            trailerId?.value === undefined
                          ) {
                            alert("Please Select Trailer");
                          } else if (
                            (divisionTo == "" ||
                              divisionTo == null ||
                              divisionTo == undefined) &&
                            props.keyTitle == moveTypeStatus.CompleteStatus
                          ) {
                            alert("Please Select Division To");
                          } else {
                            setCurrentLocation("");
                            props.setValue(payload);
                          }
                        } else if (changeType?.value == "OFFSITE") {
                          if (
                            (locationTo == "" ||
                              locationTo == null ||
                              locationTo == undefined) &&
                            props.keyTitle == moveTypeStatus.CompleteStatus
                          ) {
                            alert("Please Select Going To");
                          } else {
                            setCurrentLocation("");
                            props.setValue(payload);
                          }
                        } else {
                          setCurrentLocation("");
                          props.setValue(payload);
                        }
                      } else {
                        //create move
                        let payload = {
                          user_id: requesterName?.value, // change to number
                          division_id: division?.value,
                          changeType: changeType?.value, //Move type
                          requestDateTime: requestTime,
                          requesterName: requesterName?.label,
                          trailer_id: trailerId?.value ? trailerId.value : null,
                          outsideCarrierContainer_id:
                            containerId?.value || null,
                          doorToId: doorTo?.value ? doorTo.value : null,
                          doorFromId: doorFrom?.value ? doorFrom.value : null,
                          spaceFromId: spaceFrom?.value
                            ? spaceFrom.value
                            : null,
                          spaceToId: spaceTo?.value ? spaceTo?.value : null,
                          locationFromId: locationFrom?.value
                            ? locationFrom.value
                            : null,
                          locationToId: locationTo?.value
                            ? locationTo.value
                            : null,
                          department: department?.value
                            ? department?.value
                            : null,
                          productNum: productNumber,
                          actualCount: actualCount,
                          sealNum: sealNumber,
                          startDateTime: new Date(),
                          finishDateTime: null,
                          beforeComments: comment,
                          afterComments: "",
                          driver_id: driver?.value || null,
                          truck_id: truck?.value || null,
                          priorityMove: priorityMove, // true  false ,
                          pending: 1,
                          completed: 0,
                          requestFlag: "",
                          isEmpty:
                            trailerId != null && trailerId != ""
                              ? false
                              : isTrailerContainerChecked,
                          lotFromId: lotFrom?.value || null,
                          lotToId: lotTo?.value || null,
                          divisionToId: divisionTo?.value || null,
                          totalTime: null,
                          toDoor: goingTo?.value == "DOOR" ? "DOOR" : null, // door
                          toSpace: goingTo?.value == "SPACE" ? "SPACE" : null,
                          toYard: goingTo?.value == "YARD" ? "YARD" : null,
                          is_cancelled: false,
                        };
                        if (changeType?.value == "OFFSITE_INCOMING") {
                          if (
                            (goingTo == null || goingTo == "") &&
                            (props.keyTitle ==
                              moveTypeStatus.InProgressStatus ||
                              props.keyTitle == moveTypeStatus.CompleteStatus ||
                              (props.keyTitle == moveTypeStatus.UpdateStatus &&
                                props.keyData == "InProgressRequest"))
                          ) {
                            alert("Please Select Going To");
                          } else if (
                            (doorTo == null || doorTo == "") &&
                            goingTo?.value?.toLowerCase() == "door" &&
                            (props.keyTitle ==
                              moveTypeStatus.InProgressStatus ||
                              props.keyTitle == moveTypeStatus.CompleteStatus ||
                              (props.keyTitle == moveTypeStatus.UpdateStatus &&
                                props.keyData == "InProgressRequest"))
                          ) {
                            alert("Please Select Door ");
                          } else if (
                            (lotTo == null || lotTo == "") &&
                            goingTo?.value?.toLowerCase() == "space" &&
                            (props.keyTitle ==
                              moveTypeStatus.InProgressStatus ||
                              props.keyTitle == moveTypeStatus.CompleteStatus ||
                              (props.keyTitle == moveTypeStatus.UpdateStatus &&
                                props.keyData == "InProgressRequest"))
                          ) {
                            alert("Please Select Yard ");
                          } else if (
                            (lotTo == null || lotTo == "") &&
                            goingTo?.value?.toLowerCase() == "yard" &&
                            (props.keyTitle ==
                              moveTypeStatus.InProgressStatus ||
                              props.keyTitle == moveTypeStatus.CompleteStatus ||
                              (props.keyTitle == moveTypeStatus.UpdateStatus &&
                                props.keyData == "InProgressRequest"))
                          ) {
                            alert("Please Select Yard ");
                          } else {
                            setCurrentLocation("");
                            props.setValue(payload);
                          }
                        } else if (changeType?.value == "DC2DC") {
                          if (
                            division == "" ||
                            division == null ||
                            division == undefined
                          ) {
                            alert("Please Select Division");
                          } else {
                            setCurrentLocation("");
                            props.setValue(payload);
                          }
                        } else if (changeType?.value == "OFFSITE") {
                          if (
                            locationTo == "" ||
                            locationTo == null ||
                            locationTo == undefined
                          ) {
                            alert("Please Select Going To");
                          } else {
                            setCurrentLocation("");
                            props.setValue(payload);
                          }
                        } else {
                          setCurrentLocation("");
                          props.setValue(payload);
                        }
                      }
                    } catch (e) {}
                  }
                }}
                style={{
                  backgroundColor: "#002a4a",
                  height: "80%",
                  color: "white",
                  width: "100%",
                  borderRadius: 8,
                  borderWidth: 1,
                }}
                className="btn btn-primary"
                variant="primary"
              >
                {props.title}
              </button>
            </div>
          ) : null}

          {props.rowDataUser && props.rowDataUser != null ? null : (
            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
              <button
                onClick={() => {
                  if (
                    driver == "" &&
                    requestTime == "" &&
                    changeType == "" &&
                    departmentType == "" &&
                    requesterName == "" &&
                    productNumber == "" &&
                    actualCount == "" &&
                    sealNumber == "" &&
                    comment == "" &&
                    truck == ""
                  ) {
                    alert("All Fields are compulsory");
                  } else if (changeType == "" || changeType == null) {
                    alert("Please Select Change Type");
                  } else if (
                    (changeType?.value == "OFFSITE_INCOMING" ||
                      changeType?.value == "DC2DC" ||
                      changeType?.value == "OFFSITE_OUTGOING") &&
                    sealNumber == ""
                  ) {
                    alert("Please Enter Seal Number");
                  } else {
                    try {
                      //create move
                      let payload = {
                        user_id: requesterName?.value, // change to number
                        outsideCarrierContainer_id: containerId?.value || null,
                        division_id: division?.value,
                        changeType: changeType?.value, //Move type
                        requestDateTime: requestTime,
                        requesterName: requesterName?.label,
                        trailer_id: trailerId?.value ? trailerId.value : null,
                        doorToId: doorTo?.value ? doorTo.value : null,
                        doorFromId: doorFrom?.value ? doorFrom.value : null,
                        spaceFromId: spaceFrom?.value ? spaceFrom.value : null,
                        spaceToId: spaceTo?.value ? spaceTo?.value : null,
                        locationFromId: locationFrom?.value
                          ? locationFrom.value
                          : null,
                        locationToId: locationTo?.value
                          ? locationTo.value
                          : null,
                        department: department?.value
                          ? department?.value
                          : null,
                        productNum: productNumber,
                        actualCount: actualCount,
                        sealNum: sealNumber,
                        startDateTime: new Date(),
                        finishDateTime: null,
                        beforeComments: comment,
                        afterComments: "",
                        driver_id: driver?.value || null,
                        truck_id: truck?.value || null,
                        priorityMove: priorityMove, // true  false ,
                        pending: 1,
                        completed: 0,
                        requestFlag: "",
                        isEmpty:
                          trailerId != null && trailerId != ""
                            ? false
                            : isTrailerContainerChecked,
                        lotFromId: lotFrom?.value || null,
                        lotToId: lotTo?.value || null,
                        divisionToId: divisionTo?.value || null,
                        totalTime: null,
                        toDoor: goingTo?.value == "DOOR" ? "DOOR" : null, // door
                        toSpace: goingTo?.value == "SPACE" ? "SPACE" : null,
                        toYard: goingTo?.value == "YARD" ? "YARD" : null,
                        is_cancelled: false,
                      };
                      if (changeType?.value == "OFFSITE_INCOMING") {
                        if (
                          (goingTo == null || goingTo == "") &&
                          (props.keyTitle == moveTypeStatus.InProgressStatus ||
                            props.keyTitle == moveTypeStatus.CompleteStatus ||
                            (props.keyTitle == moveTypeStatus.UpdateStatus &&
                              props.keyData == "InProgressRequest"))
                        ) {
                          alert("Please Select Going To");
                        } else if (
                          (doorTo == null || doorTo == "") &&
                          goingTo?.value?.toLowerCase() == "door" &&
                          (props.keyTitle == moveTypeStatus.InProgressStatus ||
                            props.keyTitle == moveTypeStatus.CompleteStatus ||
                            (props.keyTitle == moveTypeStatus.UpdateStatus &&
                              props.keyData == "InProgressRequest"))
                        ) {
                          alert("Please Select Door ");
                        } else if (
                          (lotTo == null || lotTo == "") &&
                          goingTo?.value?.toLowerCase() == "space" &&
                          (props.keyTitle == moveTypeStatus.InProgressStatus ||
                            props.keyTitle == moveTypeStatus.CompleteStatus ||
                            (props.keyTitle == moveTypeStatus.UpdateStatus &&
                              props.keyData == "InProgressRequest"))
                        ) {
                          alert("Please Select Yard ");
                        } else if (
                          (lotTo == null || lotTo == "") &&
                          goingTo?.value?.toLowerCase() == "yard" &&
                          (props.keyTitle == moveTypeStatus.InProgressStatus ||
                            props.keyTitle == moveTypeStatus.CompleteStatus ||
                            (props.keyTitle == moveTypeStatus.UpdateStatus &&
                              props.keyData == "InProgressRequest"))
                        ) {
                          alert("Please Select Yard ");
                        } else {
                          setCurrentLocation("");
                          props.setValue(payload);
                        }
                      } else if (changeType?.value == "DC2DC") {
                        if (
                          division == "" ||
                          division == null ||
                          division == undefined
                        ) {
                          alert("Please Select Division");
                        } else {
                          setCurrentLocation("");
                          props.setValue(payload);
                        }
                      } else if (changeType?.value == "OFFSITE") {
                        if (
                          locationTo == "" ||
                          locationTo == null ||
                          locationTo == undefined
                        ) {
                          alert("Please Select Going To");
                        } else {
                          setCurrentLocation("");
                          props.setValue(payload);
                        }
                      } else {
                        setCurrentLocation("");
                        props.setValue(payload);
                      }
                    } catch (e) {}
                  }
                }}
                style={{
                  backgroundColor: "#002a4a",
                  height: "80%",
                  color: "white",
                  width: "100%",
                  borderRadius: 8,
                  borderWidth: 1,
                }}
                className="btn btn-primary"
                variant="primary"
              >
                {props.title}
              </button>
            </div>
          )}

          <div className="col-12 col-sm-12 col-md-4 col-lg-4">
            <button
              style={{
                backgroundColor: "#002a4a",
                height: "80%",
                color: "white",
                width: "100%",
                borderRadius: 8,
                borderWidth: 1,
              }}
              onClick={() => {
                props.show(false);
              }}
              className="btn btn-primary"
              variant="primary"
            >
              {props.keyData == "InProgressRequest" ? "Close" : "Cancel"}
            </button>
          </div>

          {props.keyData == "InProgressRequest" ? (
            <div className="col-12 col-sm-12 col-md-4 col-lg-4">
              <button
                style={{
                  backgroundColor: "#002a4a",
                  height: "80%",
                  color: "white",
                  width: "100%",
                  borderRadius: 8,
                  borderWidth: 1,
                }}
                onClick={() => {
                  if (reasonForCancellation.value == "No Issue") {
                    alert("Please Select Reason For Cancellation");
                  } else {
                    let payload = {
                      move_id: props.rowDataUser.move_id,

                      user_id: requesterName?.value, // change to number
                      division_id: division?.value,
                      changeType: changeType?.value, //Move type
                      requestDateTime: new Date(requestTime),
                      requesterName: requesterName?.label,
                      trailer_id: trailerId?.value ? trailerId.value : null,
                      outsideCarrierContainer_id:
                        containerId && containerId != "" && containerId != null
                          ? containerId?.value
                          : null,
                      doorToId: doorTo?.value ? doorTo?.value : null,
                      doorFromId: doorFrom?.value ? doorFrom?.value : null,
                      locationFromId: locationFrom?.value
                        ? locationFrom.value
                        : null,
                      locationToId: locationTo?.value ? locationTo.value : null,
                      spaceFromId: spaceFrom != null ? spaceFrom?.value : null,
                      spaceToId: spaceTo != null ? spaceTo?.value : null,
                      department: department?.value ? department?.value : null,
                      productNum: productNumber,
                      actualCount: actualCount,
                      sealNum: sealNumber,
                      driver_id: driver?.value,
                      truck_id: truck?.value,
                      startDateTime: new Date(requestTime),
                      finishDateTime: new Date(),
                      beforeComments: comment,
                      afterComments:
                        props.keyData == "InProgressRequest"
                          ? afterComment
                          : "",
                      priorityMove: priorityMove, // true  false ,
                      completed: 0,
                      pending: 0,
                      requestFlag:
                        props.keyData == "InProgressRequest"
                          ? reasonForCancellation?.value
                          : "",
                      isEmpty:
                        trailerId != null ? false : isTrailerContainerChecked,
                      lotFromId: lotFrom?.value,
                      lotToId: lotTo?.value,
                      divisionToId: divisionTo?.value,
                      totalTime:
                        props.title == "Move to Complete Request"
                          ? Math.floor(
                              (new Date() - new Date(requestTime)) / 60000
                            )
                          : null,
                      toDoor: goingTo?.value == "DOOR" ? "DOOR" : null, // door
                      toSpace: goingTo?.value == "SPACE" ? "SPACE" : null, // space
                      toYard: goingTo?.value == "YARD" ? "YARD" : null,
                      is_cancelled: true,
                    };
                    props.show(false);
                    setCurrentLocation("");
                    props.setValue(payload);
                    setContainerId("");
                  }
                }}
                className="btn btn-primary"
                variant="primary"
              >
                {"Cancel Move"}
              </button>
            </div>
          ) : null}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default OffSiteModalComp;
